import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function Warning({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex gap-4 rounded-2xl border border-[#D4AF37]/20 bg-[#D4AF37]/[0.04] p-5 md:p-6" data-id="element-1104" data-mp="o8g15jq94flr">
      <AlertTriangle className="h-5 w-5 shrink-0 text-[#D4AF37] mt-1" aria-hidden="true" data-id="element-1105" data-mp="k3zxzq80vma8" />
      <p className="text-[15px] md:text-base" data-id="element-1106" data-mp="f5oqhm579nv6">{children}</p>
    </div>;
}